import React from 'react';
import useOnlineStatus from '@rehooks/online-status';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Loading from '../partials/loading';
import LoadingNetwork from '../partials/loadingNetwork';

import { useToggleNavBar, useLoadingBar } from '../../libraries/contexts';
import { isLogged } from '../../services/authorization-service';
import { EQUIFAX_LOGO, EQUIFAX_LOGO_ALT, FALP_LOGO, FALP_LOGO_ALT } from '../../libraries/images';
import { header as styles } from './css';

const Header = props => {
  const toggleManager = useToggleNavBar();
  const loader = useLoadingBar();
  const onlineStatus = useOnlineStatus();
  const loading = loader[0];
  const { main, secondary } =
    toggleManager.length > 0 ? toggleManager[0] : { main: false, secondary: false };
  const { classes } = props;
  const isOut = !isLogged();

  return (
    <div className={classes.root}>
      <AppBar
        position="fixed"
        className={classNames(classes.appBar, {
          [classes.appBarShift]: main && !secondary,
          [classes.appBothBarShift]: main && secondary,
          [classes.appSecondaryBarShift]: secondary && !main,
          [classes.logoutBar]: isOut
        })}
      >
        <Toolbar>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignContent="center"
            alignItems="center"
          >
            <img src={EQUIFAX_LOGO} alt={EQUIFAX_LOGO_ALT} className={classes.equifaxLogo} />
          </Grid>

          <Grid container justify="flex-end" alignContent="center" alignItems="center">
            <img src={FALP_LOGO} alt={FALP_LOGO_ALT} className={classes.falpLogo} />
          </Grid>
        </Toolbar>
        {onlineStatus ? '' : <LoadingNetwork />}
        {loading.principalLoading ? <Loading /> : ''}
      </AppBar>
    </div>
  );
};

Header.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Header);
